module.exports = __webpack_public_path__ + "static/media/sm_2022.c7d51dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/sm_2022.png
// module id = 233
// module chunks = 0